import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';

// @TODO figure out if this is still in use...
// It should also use the Tile component <Tile>
export const NearbyActivities = () => (
  <div className="ActivitiesMap" data-module-name="nearby-activities">
    <ul className="ActivitiesMap-fliter">
      <li className="ActivitiesMap-fliter-item is-active">Surfing</li>
      <li className="ActivitiesMap-fliter-item">Boating</li>
      <li className="ActivitiesMap-fliter-item">Skiing</li>
    </ul>

    <div className="ActivitiesMap-map">{/* @TODO map */}</div>

    <div className="ActivitiesMap-location">
      <p className="ActivitiesMap-location-name">Lyall Bay</p>
      <LinkFactoryReactRouter href="todo">more details</LinkFactoryReactRouter>
    </div>

    <div className="ActivitiesMap-data">
      <div className="Grid">
        <div className="Grid-cell u-md-width1of2">
          <div className="Grid-cell u-width1of2">
            <strong>Surf quality</strong>
            <br /> Good (7)
          </div>
          <div className="Grid-cell u-width1of2">
            <strong>Sea temp</strong>
          </div>
        </div>
        <div className="Grid-cell u-md-width1of2">
          <strong>Days</strong>
        </div>
      </div>
    </div>
  </div>
);
